import { useNavigate } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import { Dropdown, DropdownDivider, DropdownItem } from '@/components/ui/Dropdown'
import { useAuth } from '@/auth/useAuth'

export function UserMenu() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  if (!user) return null

  return (
    <Dropdown
      align="right"
      width="w-56"
      trigger={
        <button
          type="button"
          className="flex items-center gap-1.5 rounded-[4px] px-2 py-1 text-[13px] text-ink-muted hover:bg-surface-sunk"
        >
          <span className="max-w-[200px] truncate">{user.email}</span>
          <ChevronDown size={13} aria-hidden />
        </button>
      }
    >
      {(close) => (
        <>
          <div className="px-3 py-1.5">
            <p className="font-head text-[13px] font-semibold">{user.name}</p>
            <p className="truncate text-[12px] text-ink-faint">{user.email}</p>
          </div>
          <DropdownDivider />
          <DropdownItem
            onClick={() => {
              close()
              navigate('/')
            }}
          >
            All clients
          </DropdownItem>
          <DropdownItem
            onClick={async () => {
              close()
              await signOut()
              navigate('/login', { replace: true })
            }}
          >
            Sign out
          </DropdownItem>
        </>
      )}
    </Dropdown>
  )
}
